module.exports = __webpack_public_path__ + "static/media/SerieFWS.59cfd261.png";